import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-read-more-txt',
    templateUrl: './read-more-txt.component.html',
    styleUrls: ['./read-more-txt.component.scss'],
    standalone: false
})
export class ReadMoreTxtComponent implements OnInit {
  @Input() text: string;
  @Input() maxLength: number;

  constructor() {}

  ngOnInit(): void {}

  toggleReadMore(divElement: HTMLDivElement) {
    divElement.classList.toggle('shorter-text');
  }

  slicedText(text: string) {
    return text.slice(0, 100);
  }
}
